import { render, staticRenderFns } from "./CartTable.vue?vue&type=template&id=05697f8c"
import script from "./CartTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CartTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports